import moment from 'moment';
import { transitTripsReport } from '../../../../../core/models/dashboard/data-utilization-dad.model';

export const transitCompliance = {
    searchText: '',
    addText: '',
    export: true,
    exportFile: 'Cumplimiento_de_Viaje_en_Transito.xlsx',
    expandable: true,
    filter: false,
    paginator: true,
    filterDefault: '',
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Compañía',
        name: 'companyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: transitTripsReport) => element.companyCode
      },
      {
        title: 'Código del tipo de entrega',
        name: 'deliveryTypeCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: transitTripsReport) => element.deliveryTypeCode
      },
      {
        title: 'Tipo de origen',
        name: 'originType',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: transitTripsReport) => element.originType
      },
      {
        title: 'Estado',
        name: 'status',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: transitTripsReport) => element.status
      },
      {
        title: 'Fecha de entrega',
        name: 'deliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: transitTripsReport) => moment(element.deliveryDate).format('YYYY-MM-DD')
      },
      {
        title: 'Cumplimiento Viaje en tránsito',
        name: 'complianceTransitTrip',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: transitTripsReport) => element.complianceTransitTrip
      },
      {
        title: 'Canal',
        name: 'channel',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: transitTripsReport) => element.channel
      },
      {
        title: 'Total',
        name: 'total',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w120',
        value: (element: transitTripsReport) => element.total
      }
    ],
    subTable: {}
  };
